<template>
    <div class="align-center">
        <div v-if="!!error" class="notification is-danger is-light">
            <p>{{ error }}</p>
        </div>
        <h1 v-if="deliveries" class="title is-6">Last {{currentPage * step}} deliveries for beneficiary {{ beneficiaryID }}</h1>
        <div class="block">
            <DeliveryHistoryItem v-for="delivery in deliveries" :key="delivery.fd_id" :name="delivery.full_name"
                :dryBag="delivery.dry_bag" :quantity="delivery.quantity" :unit="delivery.unit" :block="delivery.block"
                :street="delivery.street" :completed="delivery.completed" :completedAtTime="delivery.completed_at_time"
                :age="delivery.age" :deliverySort="delivery.delivery_sort" :beneficiaryID="delivery.beneficiary_id"
                :fdID="delivery.fd_id" :status="delivery.status" :selfCollection="delivery.self_collection"
                :drivingDelivery="delivery.driving_delivery" :deliveryNotes="delivery.notes">
            </DeliveryHistoryItem>
        </div>
        <base-spinner v-if="isLoading"></base-spinner>
        <div class="block">
            <button v-if="!isLoading" class="button is-info is-rounded block" @click="loadHistoricalDeliveries(currentPage + 1)">
                Load more
            </button>
        </div>
    </div>
</template>

<script>
import { lastSaturday } from '@/utils';
import { getDateInYYMMDD } from '@/utils';
import DeliveryHistoryItem from '../delivery/DeliveryHistoryItem.vue';

export default {
    components: {
        DeliveryHistoryItem
    },
    props: ['beneficiaryID'],
    data() {
        return {
            isLoading: false,
            currentPage: 0,
            step: 10,
            error: null
        }
    },
    mounted() {
        this.loadHistoricalDeliveries(1);
    },
    unmounted() {
        this.$store.dispatch('delivery/resetHistoricalDeliveries');
    },
    computed: {
        deliveries() {
            return this.$store.getters['delivery/getSearchHistoricalDeliveries'];
        }
    },
    methods: {
        async loadHistoricalDeliveries(page) {
            this.currentPage++;
            this.isLoading = true;
            const lastFDs = [];
            for (var i = (page - 1) * this.step; i < page * this.step; i++) {
                const startDate = lastSaturday();
                lastFDs.push(getDateInYYMMDD(new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() - i * 7)))
            }
            try {
                await this.$store.dispatch('delivery/searchHistoricalDeliveries', {
                    fdIDs: lastFDs,
                    beneficiaryID: this.beneficiaryID
                });
            } catch (error) {
                console.error(error);
                this.error = error;
            }
            this.isLoading = false;
        }
    }
}
</script>